module.exports = __webpack_public_path__ + "img/delete.8ed4e863.svg";